import clsx from 'clsx';
import React, { Fragment } from 'react';
import type { ISO8601Date } from 'types';
import { useTranslation } from 'utils/hooks';


import css from './NamensTimeline.module.scss';

interface NamensTimelineProps
{
  items: {
    zeitpunkt: ISO8601Date;
    text: string;
  }[];
  change: string;
  isFree?: boolean;
}

const NamensTimeline: React.FC<NamensTimelineProps> = (props) =>
{
  const { items, change, isFree = false } = props;
  const { t } = useTranslation(['formats', 'profiles']);

  function renderItem(text: string)
  {
    return (
      <dd className={css.item}>
        <span className={clsx(css.name, css.ellipsis)}>{text}</span>
        <span>{change}</span>

        <div className={css.hover}>
          <span className={css.name}>{text}</span>
          <span>{change}</span>
        </div>
      </dd>
    );
  }

  return (
    <dl className={clsx('scrollbars', css.container)}>
      {items.map((item, index) => (
        <Fragment key={change + index + item}>
          <div className={clsx(isFree && index > 1 ? css.fake : undefined)}>
            <dt>
              <h4 className={css.heading}>
                { t('formats:date', { value: item.zeitpunkt }) }
              </h4>
            </dt>
            {renderItem(item.text)}
          </div>
          {index < items.length - 1 && (
            <div className={css.line} />
          )}
        </Fragment>
      ))}
    </dl>
  );
};

export default NamensTimeline;
